// src/pages/tickets/components/TicketInfo.tsx
import { Card, Avatar } from '@/components/ui';
import { Building, Clock, Calendar } from 'lucide-react';
import { formatDateTime, formatDate } from '@/lib/utils';
import type { Ticket } from '@/types';

interface Props {
  ticket: Ticket;
}

export function TicketInfo({ ticket }: Props) {
  return (
    <Card className="p-4">
      <h3 className="font-semibold mb-4">Informacion</h3>
      <div className="space-y-4">
        {/* Cliente */}
        <div>
          <p className="text-xs text-gray-500 uppercase mb-1">Cliente</p>
          <div className="flex items-center gap-2">
            <Avatar fallback={ticket.cliente?.nombre} size="sm" />
            <span className="text-sm font-medium">{ticket.cliente?.nombre}</span>
          </div>
          {ticket.empresa && (
            <p className="text-xs text-gray-500 flex items-center gap-1 mt-1 ml-8">
              <Building className="h-3 w-3" />
              {ticket.empresa.nombre}
            </p>
          )}
        </div>

        {/* Asignado */}
        <div>
          <p className="text-xs text-gray-500 uppercase mb-1">Asignado a</p>
          {ticket.asignado_a ? (
            <div className="flex items-center gap-2">
              <Avatar fallback={ticket.asignado_a.nombre} size="sm" />
              <span className="text-sm font-medium">{ticket.asignado_a.nombre}</span>
            </div>
          ) : (
            <span className="text-sm text-gray-400">Sin asignar</span>
          )}
        </div>

        {/* Creado por */}
        <div>
          <p className="text-xs text-gray-500 uppercase mb-1">Creado por</p>
          <div className="flex items-center gap-2">
            <Avatar fallback={ticket.creado_por?.nombre} size="sm" />
            <span className="text-sm font-medium">{ticket.creado_por?.nombre}</span>
          </div>
        </div>

        {/* Fechas */}
        <div>
          <p className="text-xs text-gray-500 uppercase mb-1">Creado</p>
          <p className="text-sm flex items-center gap-1">
            <Calendar className="h-3 w-3 text-gray-400" />
            {formatDateTime(ticket.created_at)}
          </p>
        </div>

        {ticket.fecha_limite && (
          <div>
            <p className="text-xs text-gray-500 uppercase mb-1">Fecha limite</p>
            <p className="text-sm flex items-center gap-1">
              <Clock className="h-3 w-3 text-gray-400" />
              {formatDate(ticket.fecha_limite)}
            </p>
          </div>
        )}

        {ticket.fecha_resolucion && (
          <div>
            <p className="text-xs text-gray-500 uppercase mb-1">Resuelto</p>
            <p className="text-sm flex items-center gap-1">
              <Calendar className="h-3 w-3 text-green-500" />
              {formatDateTime(ticket.fecha_resolucion)}
            </p>
          </div>
        )}
      </div>
    </Card>
  );
}
